<template>
    <div
        class="
            min-h-screen
            flex flex-col
            sm:justify-center
            items-center
            pt-6
            sm:pt-0
            bg-gray-100 bg-cover-login
        "
    >
        <div
            class="
                w-full
                sm:max-w-md
                mt-5
                px-6
                py-4
                bg-white
                shadow-md
                overflow-hidden
                sm:rounded-lg
            "
        >
            <slot />
        </div>
    </div>
</template>
